import { gql } from "@apollo/client";

const Mutation = gql`
  mutation PurchaseMutation($input: PurchaseInput!) {
    purchase(input: $input) {
      success
      errorMessage
    }
  }
`;

export default Mutation;
